import { useEffect } from 'react';

const useDocumentTitleRename = (title: string | null | undefined) => {
  useEffect(() => {
    if (title) {
      document.title = title;
    }
    return () => {
      document.title = 'GX Go';
    };
  }, [title]);
};

export default useDocumentTitleRename;
